import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SlideInOutAnimation } from '@app/my-collection/components/collection-list-table/collection-list-table.animation';
import { Observable } from 'rxjs/internal/Observable';
import { MyCollection, User, VWProgram } from '@app/core/models';
import { Store, select } from '@ngrx/store';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { CollectionPriceFormulaComponent } from '@app/my-collection/components/collection-price-formula/collection-price-formula.component';
import { AppState, BrandsActionTypes, selectProfile, selectProgram } from '@app/core/ngrx';
import { MyCollectionActionTypes } from '@app/core/ngrx/actions/my-collection.actions';
import { MyCollectionService } from '@app/core/services';
import { tap } from 'rxjs/operators';
import { AlertDialogComponent } from '@app/shared/components';
@Component({
  selector: 'ecp-collection-list-table',
  templateUrl: './collection-list-table.component.html',
  styleUrls: ['./collection-list-table.component.scss'],
  animations: [SlideInOutAnimation],
})
export class CollectionListTableComponent implements OnInit {
  public changesDetected: boolean;
  ParentExample = 'Hello Angular!';
  // @select(['mycollection', 'list', 'brands'])
  // public mycollections$: Observable<MyCollection[]>;
  public mycollections$: Observable<any>;
  // @select(['mycollection'])
  //public collections$: Observable<MyCollection[]>;
  public collections$: Observable<any>;
  // @select(['mycollection', 'selectedBrand'])
  public selectedBrand$: Observable<string>;
  // @select(['mycollection', 'searchTerm'])
  public searchTerm$: Observable<string>;
  // @select(['user', 'profile'])
  user$: Observable<User>;
  @ViewChild('sortSection') sortSection: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  public brand: any = {};
  public searchTerm = '';
  public slowFrameCount = 0;
  public modulePriceFormula = [];
  private brands = [];
  // @select(['user', 'profile', 'program'])
  public program$: Observable<VWProgram>;
  theme = 'one-portal';
  formulaSubmitted: boolean;
  panelDisplay: Array<number> = [];
  constructor(
    public dialog: MatDialog,
    private store: Store<AppState>,
    private myCollectionService: MyCollectionService,
  ) {}

  ngOnInit(): void {
    this.mycollections$ = this.store.pipe(
      tap(state => {
        const updatedBrands = state.myCollection.list.brands.map((brand, index) => {
          const updatedModules = brand.modules.map((module, moduleIndex) => ({
            ...module,
            index: moduleIndex,
          }));
          return {
            ...brand,
            index,
            modules: updatedModules,
          };
        });
      }),
      select(state => state.myCollection.list.brands),
    );

    this.collections$ = this.store.pipe(select(state => state.myCollection));
    this.selectedBrand$ = this.store.pipe(select(state => state.myCollection.selectedBrand));
    this.searchTerm$ = this.store.pipe(select(state => state.myCollection.searchTerm));
    this.user$ = this.store.pipe(select(selectProfile));
    this.program$ = this.store.pipe(select(selectProgram));
    this.program$.pipe().subscribe(program => {
      if (program) {
        this.theme = program.programKey;
      }
    });
    this.collections$.pipe().subscribe((myCollection: any) => {
      if (myCollection.loaded) {
        this.formulaSubmitted = false;
        let brands = myCollection.list.brands;
        this.brands = brands;
        this.modulePriceFormula = [];
        brands.forEach(brand => {
          brand.modules.forEach(module => {
            if (module.retailPricingFormula) {
              this.modulePriceFormula.push({
                moduleId: module.moduleId,
                formula: module.retailPricingFormula,
              });
            }
          });
        });
      }
    });
    this.selectedBrand$.subscribe(selectedBrand => {
      this.brand = { ...this.brand, selectedBrand: selectedBrand };
    });

    this.searchTerm$.subscribe(searchTerm => {
      this.searchTerm = searchTerm;
    });
  }

  openPriceFormulaDialog(frames, moduleName, moduleId, brandId): void {
    let dialogRef = this.dialog.open(CollectionPriceFormulaComponent, {
      width: '600px',
      maxWidth: '89.3vw',
      maxHeight: '82vh',
      data: {
        values: {
          framesList: frames,
          moduleName: moduleName,
          moduleId: moduleId,
        },
      },
    });

    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        if (value.retailPricingFormula) {
          this.changesDetected = true;
          this.store.dispatch({
            type: MyCollectionActionTypes.UPDATE_RETAIL_PRICE,
            payload: {
              brandId: brandId,
              moduleId: moduleId,
              frames: value.frameList,
              retailPricingFormula: value.retailPricingFormula
            },
          });
        }
      }
    });
  }

  openPriceFormulaDialogCluster(frames, clusterName, clusterId, brandId): void {
    let dialogRef = this.dialog.open(CollectionPriceFormulaComponent, {
      width: '600px',
      maxWidth: '89.3vw',
      maxHeight: '82vh',
      data: {
        values: {
          framesList: frames,
          moduleName: clusterName,
          clusterId: clusterId,
        },
      },
    });

    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        if (value.retailPricingFormula) {
          this.changesDetected = true;
          this.store.dispatch({
            type: MyCollectionActionTypes.UPDATE_RETAIL_PRICE,
            payload: {
              brandId: brandId,
              clusterId: clusterId,
              frames: value.frameList,
              retailPricingFormula: value.retailPricingFormula
            },
          });
        }
      }
    });
  }

  sortData(sort: Sort): void {
    const matSortHeaderEls: Element[] = [].slice.call(
      this.sortSection.nativeElement.querySelectorAll('[mat-sort-header]'),
    );
    matSortHeaderEls.forEach(matSortHeaderEl => matSortHeaderEl.removeAttribute('aria-sort'));

    if (!sort.active || !sort.direction) {
      return;
    }

    const sortheader = this.sortSection.nativeElement.querySelector(`[mat-sort-header="${sort.active}"]`);
    if (sortheader) {
      sortheader.setAttribute('aria-sort', sort.direction);
    }
  }

  saveSlowFrames(brand) {
    const slowFrames = [];
    if (brand.hasClusters) {
      brand.clusters.forEach(cluster => {
        cluster.frames.forEach(frame => {
          if (frame.isSlowFrame == true) slowFrames.push(frame);
        });
      });
    }
    brand.modules.forEach(module => {
      module.frames.forEach(frame => {
        if (frame.isSlowFrame == true) slowFrames.push(frame);
      });
    });

    this.myCollectionService.saveSlowFrames(slowFrames).subscribe(() => {
      this.store.dispatch({
        type: MyCollectionActionTypes.LOAD_MY_COLLECTION,
      });
    });
  }

  getRetailPriceRequest(brands) {
    const priceList = [];
    const formulaList = [];
    for (let b of brands) {
      for (let m of b.modules) {
        if (m.retailPricingFormula && m.isMyPickModule === false) {
          formulaList.push({
            moduleId: m.moduleId,
            formula: JSON.stringify(m.retailPricingFormula),
          });
        }
        for (let f of m.frames) {
          if (f.retailPrice) {
            priceList.push({
              fpc: f.fpc,
              price: f.retailPrice,
            });
          }
        }
      }
    }
    return {
      moduleFormulas: formulaList,
      retailPrices: priceList,
    };
  }

  saveRetainPrices() {
    this.formulaSubmitted = true;
    let retailPrices = [];
    let priceFormulas = [];
    this.brands.forEach(brand => {
      if (brand.hasClusters) {
        brand.clusters.forEach(cluster => {
          // if (cluster.retailPricingFormula) {
          //   priceFormulas.push({
          //     clusterId: cluster.clusterId,
          //     formula: cluster.retailPricingFormula.formula,
          //   });
          // }
          priceFormulas.push({
            clusterId: cluster.clusterId || '',
            formula: cluster?.retailPricingFormula?.formula || '',
          });

          cluster.frames.forEach(frame => {
            if (frame.retailPrice) {
              retailPrices.push({
                fpc: frame.fpc,
                price: frame.retailPrice.replace('$', ''),
              });
            }
          });
        });
      } else {
        brand.modules.forEach(module => {
          // if (module.retailPricingFormula) {
          //   priceFormulas.push({
          //     moduleId: module.moduleId,
          //     formula: module.retailPricingFormula.formula,
          //   });
          // }
          priceFormulas.push({
            moduleId: module.moduleId || '',
            formula: module?.retailPricingFormula?.formula || '',
          });
          module.frames.forEach(frame => {
            if (frame.retailPrice) {
              retailPrices.push({
                fpc: frame.fpc,
                price: frame.retailPrice.replace('$', ''),
              });
            }
          });
        });
      }
    });

    this.myCollectionService
      .saveRetailPrices({
        moduleFormulas: priceFormulas,
        retailPrices: retailPrices,
      })
      .subscribe(() => {
        this.dialog.open(AlertDialogComponent, {
          width: '364px',
          maxWidth: '90vw',
          data: {
            title: 'Retail price formula',
            content: `Retail price formula has been successfully updated`,
            confirmBtnText: 'Acknowledge',
          },
          disableClose: true,
        });
        this.changesDetected = false;
        this.store.dispatch({
          type: MyCollectionActionTypes.SAVE_ALL_RETAIL_PRICE_CHANGES,
        });
      });
  }

  discardChanges() {
    this.changesDetected = false;
    this.store.dispatch({ type: MyCollectionActionTypes.REVERT_RETAIL_PRICE_CHANGES });
  }

  valueChanged() {
    this.changesDetected = true;
  }

  updateCount(checked, frame) {
    var count = 0;
    const brand = this.brands.find(b => b.brandId === frame.brandId);
    brand.modules.forEach(module => {
      count += module.frames.filter(item => item.isSlowFrame == true).length;
    });
    brand.isMaxCountReached = count >= brand.maxCustomFrames;

    this.slowFrameCount = brand.maxCustomFrames - count;
  }
}
